export default __webpack_public_path__ + "static/media/logo.eea7f6fc.svg";